module.exports = __webpack_public_path__ + "static/media/graph_data.07abd487.svg";